export default "/images/ditforsikringshus.avif?1aebd65cd28375c262727158b30334de";